export default class {
    constructor (lodash, PrivilegeService) {
        this.lodash = lodash;
        this.PrivilegeService = PrivilegeService;
    }

    getFirstReportState () {
        const candidates = [
            ['overview', () => this.PrivilegeService.canViewOverviewReport()],
            ['courseprogress', () => this.PrivilegeService.canViewEmployeeCourseProgressReport()],
            ['courses', () => this.PrivilegeService.canViewCoursesAndTargetedEmployeesReport()],
            ['users', () => this.PrivilegeService.canViewEmployeeResultsReport()],
            ['courseresults.overview', () => this.PrivilegeService.canViewCoursesResultReport()],
            ['licencereport', () => this.PrivilegeService.canViewLicencePointsReport()]
        ];
        const match = candidates.find(([, check]) => check());
        return match ? `authorized.reports.${match[0]}` : '';
    }

    buildQueryString (filter, mapPostParamsAsGet = {}) {
        return this.lodash.map(this.lodash.pickBy(filter, v => v !== null && v !== undefined), (value, prop) => {
            if (value instanceof Array) {
                return this.lodash.map(value, (value2) => {
                    return `${mapPostParamsAsGet[prop] ? mapPostParamsAsGet[prop] : prop}=${value2}`;
                }).join('&');
            }
            return `${prop}=${value}`;
        }).join('&');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/report/index.js